"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  padding: 3px 8px;\n  border-radius: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledDiv = (0, _styledComponents.default)('div')(_templateObject(), function (props) {
  return props.theme.palette[props.color].main;
}, function (props) {
  return props.theme.palette.getContrastText(props.theme.palette[props.color].main);
}, function (props) {
  return props.theme.typography.fontFamily;
}, function (props) {
  return props.theme.typography.caption.fontSize;
}, function (props) {
  return props.rounded ? '25px' : '0px';
});

var Flag = function Flag(_ref) {
  var children = _ref.children,
      color = _ref.color,
      rounded = _ref.rounded,
      props = _objectWithoutProperties(_ref, ["children", "color", "rounded"]);

  return _react.default.createElement(StyledDiv, Object.assign({
    item: true,
    color: color,
    rounded: rounded
  }, props), children);
};

Flag.defaultProps = {
  color: 'primary',
  rounded: false
};
var _default = Flag;
exports.default = _default;